import 'angular:locale/data:es-CL';
import 'zone.js';(globalThis.$localize ??= {}).locale = "es-CL";
